import {Input, Switch, Tag} from 'antd'
import {createValue} from 'components/form/utils'
import {useAppConfig} from 'modules/local'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext} from 'react'
import {Link} from 'react-router-dom'
import {DelayRender} from 'views/Discovery/DelayRender'
import {paths} from 'views/MainPage/contains'
import {NullAsDefault} from 'views/Shared'
import _ from "lodash";
import categoryIcons from "../../../conts/categoryIcons";
import {LayoutContext} from "../../../components/layouts/Default/LayoutContext";

const CurrentTags = ({items = [], onClosed, onClick = NullAsDefault}) => {
    const appConfig = useAppConfig()
    const {categories = []} = appConfig
    return (
        <DelayRender>
            {() =>
                categories
                    .filter(({id}) => items[id])
                    .map(({id, name, language, alt_idname}, index) => {
                        const Icon = _.get(categoryIcons, id, categoryIcons["default"])
                        return (
                            <Tag
                                key={index}
                                open={true}
                                closable={!!onClosed}
                                onClose={(e) => onClosed(id)}
                                style={{padding: '0.5em 0.85em', borderRadius: 6}}
                                icon={<Icon size={20}/>}
                                className="mr-0 w-fit flex items-center gap-2 border border-color-50 hover:shadow-xs cursor-pointer">
                                <Link
                                    onClick={onClick}
                                    className="font-semibold text-sm no-underline"
                                    to={`${paths.categoryPath
                                        .replace(':category', id)}`}>
                                    {name}
                                </Link>
                            </Tag>
                        )
                    })
            }
        </DelayRender>
    )
}

const AllCategoriesFilter = ({
                                 onChange,
                                 className,
                                 onRemoved,
                                 callback = NullAsDefault,
                                 following = false,
                                 selectedCategories = [],
                                 ...props
                             }) => {
    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)


    return (
        <div className={className}>
            <div className="w-full flex flex-col gap-3">
                <div className='flex items-center gap-6'>
                    <Input
                        style={{borderRadius: 6}}
                        name="keyword"
                        placeholder={t('filter')}
                        onChange={onChange}
                    />
                    <div className="flex whitespace-no-wrap">
                        <Switch
                            className="w-fit"
                            checkedChildren={isLg && <label className="font-medium italic tracking-wide">{t('following')}</label>}
                            unCheckedChildren={isLg && <label className="font-medium text-color-300 italic tracking-wide">{t('all')}</label> }
                            defaultChecked={following}
                            onChange={(value) => {
                                onChange(createValue('following', value))
                            }}
                        />
                    </div>
                </div>
                {selectedCategories && (
                    <div className="flex flex-col gap-1">
                        <span className="font-semibold text-sm text-color-100 italic">
                            {`${t('following categories')} : `}
                        </span>
                        <div className="flex flex-wrap gap-x-3 gap-y-2">
                            <CurrentTags
                                onClick={callback}
                                onClosed={onRemoved}
                                items={selectedCategories}
                            />
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default AllCategoriesFilter
